module.exports = __webpack_public_path__ + "static/media/pound-sign.64a69f25.svg";